/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Component, ElementRef, OnInit, inject, input, output, ChangeDetectionStrategy } from '@angular/core'
import { EventTypes } from '../../models/event-types'

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  private el = inject(ElementRef)

  readonly disposeEvent = output()
  readonly type = input.required<EventTypes>()
  readonly title = input.required<string>()
  readonly message = input.required<string>()

  ngOnInit() {
    this.show()
  }

  async show() {
    const bs = await import('bootstrap')
    const toastEl = this.el.nativeElement.querySelector('.toast')
    const toast = new bs.Toast(toastEl, {
      delay: this.type() === EventTypes.Error ? 5000 : 3000,
    })
    toastEl.addEventListener('hidden.bs.toast', () => this.hide(), { once: true })
    toast.show()
  }

  hide() {
    this.disposeEvent.emit()
  }
}
